import React, { useState, useEffect } from 'react'
import { getUserInfo } from '../../common/cookie';
import UserApi from '../../api/UserApi';
import PageNavigation from '../pageNavigation/PageNavigation';
import UserRegisterPop from '../../popup/UserRegisterPop';
import UserAddSlotPop from '../../popup/UserAddSlotPop';

const pageOptions = [
    { key: 10, value: 10, text: '10개씩 보기' },
    { key: 20, value: 20, text: '20개씩 보기' },
    { key: 50, value: 50, text: '50개씩 보기', active: true, selected: true },
    { key: 100, value: 100, text: '100개씩 보기' }
]

const getUserType = (type) => {
    if (type === '001') return '관리자';
    if (type === '011') return '총판관리자';
    return '일반';
}

const UserList = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [list, setList] = useState([]);
    const [curPage, setCurPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [pageCount, setPageCount] = useState(50);
    const [keyword, setKeyword] = useState('');
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRegisterOpen, setIsRegisterOpen] = useState(false);
    const [isAddSlotOpen, setIsAddSlotOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [targetUser, setTargetUser] = useState(null);

    // FUNCTION
    const init = (page = curPage, count = pageCount, searchKeyword = keyword) => {
        setIsLoading(true);
        UserApi.getUserList({ page, count, keyword: searchKeyword }).then(rslt => {
            const { data: { list, totalCount } } = rslt;
            // 각 아이템에 checked 속성 추가
            const listWithChecked = list.map(item => ({ ...item, checked: false }));
            setList(listWithChecked);
            setCurPage(page);
            setTotalCount(totalCount);
            setIsLoading(false);
        });
    }

    // EVENT
    const handleAddClick = () => {
        setIsRegisterOpen(true);
    }

    const handleDeleteClick = () => {
        const targets = getCheckedItems();
        if (targets.length === 0) {
            alert('선택된 항목이 없습니다.');
            return;
        }
        console.log('삭제할 항목들:', targets);
    }

    const getCheckedItems = (target = list) => {
        return target.filter(item => item.checked);
    }

    const handleItemChecked = item => {
        console.log('체크박스 클릭:', item.USER_ID, '현재 상태:', item.checked);
        const newList = list.map(i => item.USER_ID === i.USER_ID ? { ...i, checked: !i.checked } : i);
        console.log('새로운 리스트:', newList.map(i => ({ USER_ID: i.USER_ID, checked: i.checked })));
        setList(newList);
    }

    const handlePageChange = page => {
        console.log('page', page, curPage);
        if (page === curPage) return;
        setCurPage(page);
        init(page);
    }

    const handleSearch = () => {
        init(1, pageCount, keyword);
    }

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    const handleCountSelect = (e) => {
        const newCount = parseInt(e.target.value);
        setPageCount(newCount);
        init(1, newCount);
    }

    const handleCheckAllClick = () => {
        const newChecked = !isCheckedAll;
        setIsCheckedAll(newChecked);
        setList(list.map(item => ({ ...item, checked: newChecked })));
    }

    const handleEditClick = (item) => {
        setTargetUser(item);
        setIsRegisterOpen(true);
    }

    const handleCloseRegister = (shouldRefresh) => {
        setTargetUser(null);
        setIsRegisterOpen(false);
        if (shouldRefresh) {
            init();
        }
    }

    const handleAddSlotClick = (item) => {
        console.log('추가할 항목:', item);
        setSelectedUser(item);
        setIsAddSlotOpen(true);
    }

    const handleCloseAddSlot = (shouldRefresh) => {
        setIsAddSlotOpen(false);
        if (shouldRefresh) {
            init();
        }
    }

    // EFFECT
    useEffect(() => {
        const userInfo = getUserInfo();
        if (userInfo) setIsAdmin(userInfo.isAdmin);
    }, []);


    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        const checkedItems = getCheckedItems(list);
        const newIsCheckedAll = list.length > 0 && checkedItems.length === list.length;
        console.log('전체 선택 상태 업데이트:', {
            listLength: list.length,
            checkedItemsLength: checkedItems.length,
            isCheckedAll: newIsCheckedAll
        });
        setIsCheckedAll(newIsCheckedAll);
    }, [list]);

    return (
        <>
            <div className="filter-area">
                <div className="filter-search">
                    <span>{getCheckedItems().length}개 선택</span>
                    <div className="field-search">
                        <input 
                            value={keyword}
                            placeholder="아이디" 
                            onChange={(e) => setKeyword(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <button type="button" onClick={handleSearch}>
                            <i className="icon icon-search"></i>
                        </button>
                    </div>
                </div>
                <div className="filter-control">
                    <button type="button" className="btn" onClick={handleAddClick}>추가</button>
                    <button type="button" className="btn" onClick={handleDeleteClick}>삭제</button>
                </div>
            </div>

            <div className="table-area">
                <table className="sortable">
                    <colgroup>
                        <col width="40px" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="8%" />
                        <col width="8%" />
                        <col width="6%" />
                        <col width="6%" />
                        <col width="6%" />
                        <col width="" />
                        <col width="50px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="sorttable_nosort">
                                <label className="checkbox">
                                    <input 
                                        type="checkbox" 
                                        checked={isCheckedAll} 
                                        onChange={handleCheckAllClick}
                                    />
                                    <span></span>
                                </label>
                            </th>
                            <th className="sorttable_nosort">아이디</th>
                            <th className="sorttable_nosort">상위 아이디</th>
                            <th className="sorttable_nosort">비밀번호</th>
                            <th className="sorttable_nosort">권한</th>
                            <th className="sorttable_nosort">회사</th>
                            <th className="sorttable_nosort">수량</th>
                            <th className="sorttable_nosort">슬롯추가</th>
                            <th className="sorttable_nosort">메모</th>
                            <th className="sorttable_nosort">수정</th>
                        </tr>
                    </thead>
                    <tbody>
                    {list.map((item, index) => (
                        <tr key={`user_${item.USER_ID}`}>
                            <td>
                                <input 
                                    type='checkbox' 
                                    checked={item.checked} 
                                    onChange={() => handleItemChecked(item)} 
                                />
                            </td>
                            <td>{item.USER_ID}</td>
                            <td>{item.USER_P_ID || '-'}</td>
                            <td>{item.USER_PW}</td>
                            <td>{getUserType(item.USER_TYPE)}</td>
                            <td>{item.USER_ORG}</td>
                            <td>{item.SLOT_COUNT}</td>
                            <td><a onClick={() => handleAddSlotClick(item)}>추가</a></td>   
                            <td className="memo-cell" title={item.USER_MEMO}>{item.USER_MEMO}</td>
                            <td>
                                <a onClick={() => handleEditClick(item)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none"><path fill="#45484C" d="M0 11.077h12.923V12H0zM10.8 3.23a.89.89 0 0 0 0-1.293L9.138.277a.89.89 0 0 0-1.292 0L.923 7.2v2.954h2.954zM8.492.923l1.662 1.662-1.385 1.384-1.661-1.661zM1.846 9.231V7.569l4.616-4.615 1.661 1.661-4.615 4.616z"></path></svg>
                                </a>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                <tfoot></tfoot></table>
            </div>

            <div className="table-nav">
                <PageNavigation
                    totalCount={totalCount}
                    showCount={pageCount}
                    onChange={handlePageChange}
                />
                <div className="table-nav-row">
                    <div>
                        <select onChange={handleCountSelect} value={pageCount}>
                            {pageOptions.map(option => (
                                <option key={option.key} value={option.value}>{option.text}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            {isRegisterOpen && <UserRegisterPop close={handleCloseRegister} userData={targetUser} />}
            {isAddSlotOpen && <UserAddSlotPop close={handleCloseAddSlot} userData={selectedUser} />}
        </>
    )
}

export default UserList; 